import React from "react";

const SecureLock = ({ width = 16, height = 16, ...props }: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      {...props}
    >
      <path
        fill="#23B339"
        d="M8 11.568a1.087 1.087 0 1 0 0-2.174 1.087 1.087 0 0 0 0 2.174Z"
      />
      <path
        fill="#23B339"
        d="M12.187 6.352v-.833c0-1.8-.433-4.187-4.186-4.187-3.754 0-4.187 2.387-4.187 4.187v.833c-1.867.233-2.48 1.18-2.48 3.507v1.24c0 2.733.833 3.566 3.567 3.566h6.2c2.733 0 3.566-.833 3.566-3.566v-1.24c0-2.327-.613-3.274-2.48-3.507Zm-4.186 6.14a2.016 2.016 0 0 1-2.014-2.013c0-1.114.907-2.014 2.014-2.014a2.02 2.02 0 0 1 2.013 2.014c0 1.113-.9 2.013-2.013 2.013Zm-3.1-6.2h-.154v-.773c0-1.954.554-3.254 3.254-3.254s3.253 1.3 3.253 3.254v.78H4.901v-.007Z"
      />
    </svg>
  );
};

export default SecureLock;
